import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

type Props = {
  onClose: () => void;
  onSubmit: (form: Record<string, any>) => void;
};

const fieldOptions = [
  { name: 'email', label: 'Email Address', type: 'email' },
  { name: 'date', label: 'Execution Date', type: 'date' },
  { name: 'description', label: 'Description / Notes', type: 'textarea' },
  { name: 'agree', label: 'I confirm this action', type: 'checkbox' },
  { name: 'reason', label: 'Reason', type: 'text' },
  { name: 'approver', label: 'Approver Email', type: 'email' },
  { name: 'project', label: 'Project Name', type: 'text' },
];

const WorkflowInputModal: React.FC<Props> = ({ onClose, onSubmit }) => {
  const [selectedFields, setSelectedFields] = useState<typeof fieldOptions>([]);
  const [formValues, setFormValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const shuffled = [...fieldOptions].sort(() => 0.5 - Math.random());
    const picked = shuffled.slice(0, Math.floor(Math.random() * 2) + 4); // Pick 4–5
    setSelectedFields(picked);
  }, []);

  const handleChange = (name: string, value: any) => {
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSubmit(formValues);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
      <div className="bg-neutral-900 border border-neutral-800 p-6 rounded-xl shadow-xl w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-white"
        >
          <X className="w-5 h-5" />
        </button>
        <h2 className="text-lg font-semibold text-white mb-4">Workflow Input Required</h2>

        <div className="space-y-4">
          {selectedFields.map((field) => (
            <div key={field.name}>
              <label className="text-sm text-gray-300 mb-1 block">{field.label}</label>
              {field.type === 'textarea' ? (
                <textarea
                  rows={3}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-md text-sm text-white px-3 py-2 focus:outline-none"
                  onChange={(e) => handleChange(field.name, e.target.value)}
                />
              ) : field.type === 'checkbox' ? (
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    className="accent-indigo-600"
                    onChange={(e) => handleChange(field.name, e.target.checked)}
                  />
                  <span className="text-sm text-gray-400">{field.label}</span>
                </div>
              ) : (
                <input
                  type={field.type}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-md text-sm text-white px-3 py-2 focus:outline-none"
                  onChange={(e) => handleChange(field.name, e.target.value)}
                />
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 text-right">
          <button
            onClick={handleSubmit}
            className="bg-indigo-600 hover:bg-indigo-700 text-white text-sm px-4 py-2 rounded-md"
          >
            Submit Workflow
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkflowInputModal;
